import { useMutation, useQueryClient } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { useTranslation } from 'react-i18next';
import { ApiError } from 'src/types/interfaces/api-error';

import { settingsApi } from '../../api/lib/settings';
import { gdprKeys } from '../../api/query-keys/gdpr';

export const useRemoveGDPRClause = (onSuccess?: () => void) => {
  const queryClient = useQueryClient();
  const { t } = useTranslation(['settings']);

  return useMutation({
    mutationFn: (gdprClauseId: number) => settingsApi.deleteGdprClause(gdprClauseId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: gdprKeys.all,
      });
      onSuccess?.();
      toast.success(t('settings:gdpr.deleteSuccess'));
    },
    onError: (error: ApiError) => {
      toast.error(error?.response?.data?.message);
    },
  });
};
